import $ from "jquery";
import {reachGoal} from "js/utils/analytics";

export const initUp = () => {
    let $backTop = $('#back-top')
    $backTop.hide();

    up($(window), $backTop)

    $(window).scroll(function () {
        up($(this), $backTop)
    });
    $backTop.find('a').click(function () {
        reachGoal('up')
        $('body,html').animate({scrollTop: 0}, 800);
        return false;
    });
}

function up($this, $backTop) {
    $this.scrollTop() > 100 ? $backTop.fadeIn() : $backTop.fadeOut();
}
